'use strict';

/**
 *
 * @name: registerDoubanFactory
 *
 */

function RegisterDoubanFactory($rootScope, $q, $http, $sessionStorage) {

  'ngInject';

  var apiKey = $rootScope.doubanKey;

  function login(whereFrom) {

    if (whereFrom === 'connections') {
      $sessionStorage.Nowness.douban = whereFrom;
    }

    if (whereFrom === 'mergeFromConfirm') {

      $sessionStorage.Nowness.douban = whereFrom;
    }

    if (whereFrom === 'loginButton') {

      $sessionStorage.Nowness.signUpFromLoginButton = 1;
    }
    //豆瓣登录 bysxz
    // var url = 'https://www.douban.com/service/auth2/auth?client_id=' + apiKey + '&redirect_uri=' + $rootScope.appDist + '/douban&response_type=code&scope=shuo_basic_r,shuo_basic_w,douban_basic_common';
    var url = 'https://www.douban.com/service/auth2/auth?client_id=' + apiKey + '&redirect_uri=https://www.nowness.cn' + '/douban&response_type=code&scope=shuo_basic_r,shuo_basic_w,douban_basic_common';
    window.location.href = url;
  }

  return {
    login: login
  };
}

export default RegisterDoubanFactory;



// WEBPACK FOOTER //
// ./app/components/nn-register/nn-register-douban.factory.js